module.exports = "<span [ngClass]=\"{'text-dark': idEstado == 1, 'text-warning': idEstado == 2 , 'text-success': idEstado == 3  , 'text-danger': idEstado == 4, 'text-primary': idEstado == 5, 'amber-text': idEstado == 6}\">{{estado}}</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/text/state/state.component.html
// module id = ./src/app/shared/components/text/state/state.component.html
// module chunks = main